let actx = null;
export const sfxOn = () => localStorage.getItem("xp_sound_on") !== "0";
const ctx = () => (actx = actx || new (window.AudioContext || window.webkitAudioContext)());

const tone = (type, f0, f1, dur, vol, when = 0) => {
  const c = ctx();
  const t = c.currentTime + when;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(f0, t);
  if (f1) o.frequency.exponentialRampToValueAtTime(f1, t + dur);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(vol, t + 0.006);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(c.destination);
  o.start(t);
  o.stop(t + dur + 0.03);
};

export const marbleClack = (vol = 0.09) => {
  if (!sfxOn()) return;
  try { tone("triangle", 2400 + Math.random() * 900, 1500, 0.045, vol); tone("sine", 3400, 2400, 0.03, vol * 0.6); } catch { /* audio unavailable */ }
};
export const flickThwip = () => {
  if (!sfxOn()) return;
  try { tone("sine", 240, 700, 0.09, 0.07); } catch { /* audio unavailable */ }
};
export const knockPing = () => {
  if (!sfxOn()) return;
  try { tone("sine", 880, 1760, 0.22, 0.09); tone("sine", 1320, 2640, 0.18, 0.05, 0.03); } catch { /* audio unavailable */ }
};
export const cheerArp = () => {
  if (!sfxOn()) return;
  try { [523, 659, 784, 1046].forEach((f, i) => tone("triangle", f, null, 0.16, 0.07, i * 0.09)); } catch { /* audio unavailable */ }
};
export const clonk = (vol = 0.1) => {
  if (!sfxOn()) return;
  try { tone("triangle", 220, 120, 0.16, vol); } catch { /* audio unavailable */ }
};
export const whipCrack = () => {
  if (!sfxOn()) return;
  try {
    const c = ctx();
    const t = c.currentTime;
    const b = c.createBuffer(1, c.sampleRate * 0.12, c.sampleRate);
    const d = b.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 2.2);
    const src = c.createBufferSource();
    src.buffer = b;
    const hp = c.createBiquadFilter();
    hp.type = "highpass";
    hp.frequency.value = 1200;
    const g = c.createGain();
    g.gain.value = 0.22;
    src.connect(hp).connect(g).connect(c.destination);
    src.start(t);
    tone("sine", 900, 180, 0.08, 0.08);
  } catch { /* audio unavailable */ }
};
export const spinHum = () => {
  if (!sfxOn()) return null;
  try {
    const c = ctx();
    const o = c.createOscillator();
    const g = c.createGain();
    const lp = c.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 500;
    o.type = "sawtooth";
    o.frequency.value = 120;
    g.gain.value = 0.0001;
    o.connect(lp).connect(g).connect(c.destination);
    o.start();
    return {
      set(vel) { try { o.frequency.value = 60 + vel * 2.4; g.gain.value = 0.004 + (vel / 110) * 0.02; } catch { /* noop */ } },
      stop() { try { g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.15); o.stop(c.currentTime + 0.25); } catch { /* noop */ } },
    };
  } catch { return null; }
};
